import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            为什么选择吃瓜入口
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            五大核心优势，打造最专业、最全面的黑料吃瓜平台
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-6 text-center hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}